(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AgenziaDeleteController',AgenziaDeleteController);

    AgenziaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Agenzia'];

    function AgenziaDeleteController($uibModalInstance, entity, Agenzia) {
        var vm = this;

        vm.agenzia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Agenzia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
